import React from 'react';
import { Paper } from '@mui/material';
import AdminDataTable from '../AdminDataTable';
import AdminPagination from '../AdminPagination';

export default function ResponsiveDataView({
    columns,
    rows,
    orderBy,
    orderDirection,
    onSort,
    onRowClick,
    mobileCardRenderer,
    mobileBreakpoint,
    emptyMessage,
    page,
    pageSize,
    total,
    onPageChange,
    onPageSizeChange,
    paperSx = {},
}) {
    return (
        <Paper
            sx={{
                borderRadius: '12px',
                overflow: 'hidden',
                boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
                border: '1px solid #f0f0f0',
                ...paperSx,
            }}
        >
            <AdminDataTable
                columns={columns}
                rows={rows}
                orderBy={orderBy}
                orderDirection={orderDirection}
                onSort={onSort}
                onRowClick={onRowClick}
                mobileCardRenderer={mobileCardRenderer}
                mobileBreakpoint={mobileBreakpoint}
                emptyMessage={emptyMessage}
            />
            {(typeof page === 'number' && typeof pageSize === 'number' && typeof total === 'number') && (
                <AdminPagination
                    page={page}
                    pageSize={pageSize}
                    total={total}
                    onPageChange={onPageChange}
                    onPageSizeChange={onPageSizeChange}
                />
            )}
        </Paper>
    );
}
